module.exports = __webpack_public_path__ + "img/20191114165809360截图20191114161049359.e23e552c.jpg";